export const LpTokenEvents = {
  GetBalance: 'LpToken.GetBalance',
  BalanceReturned: 'LpToken.BalanceReturned',

  GetTotalArmorStaked: 'LpToken.GetTotalArmorStaked',
  TotalArmorStakedReturned: 'LpToken.TotalArmorStakedReturned',

  Approve: 'LpToken.Approve',
  ApproveCompleted: 'LpToken.ApproveCompleted',
}
